import { useTranslation } from "react-i18next";
import "./About.css";

const About = () => {
    const { t } = useTranslation();

    return (
        <main className="About border-shadow w-50 m-a">
            <h1>{t("about.title")}</h1>
            <img src="/images/oma_kuva.webp" alt={t("about.imageAlt")} width="573" height="559" loading="lazy" decoding="async" />
            <p>{t("about.paragraph1")}</p>
            <p>{t("about.paragraph2")}</p>
        </main>
    );
};
export default About;
